import React from "react";
import { useLocation } from "react-router-dom";

import EndorsementHistoryEdit from "pages/EndorsementHistoryEdit";

const EnrolmentEdit = () => {
  const { state } = useLocation();

  return (
    <section
      style={{
        width: "1000px",
      }}
    >
      <EndorsementHistoryEdit detail={state} />
    </section>
  );
};

export default EnrolmentEdit;
